var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovernanceLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9038 24.9365C15.8438 23.1968 20 20.1973 20 14.1983V5.79974C20 5.48153 19.8749 5.17636 19.6522 4.95135C19.4295 4.72634 19.1274 4.59994 18.8125 4.59994C16.4375 4.59994 13.4806 3.17218 11.4025 1.33648C11.1509 1.11932 10.8309 1 10.5 1C10.1691 1 9.84908 1.11932 9.5975 1.33648C7.53125 3.16018 4.5625 4.59994 2.1875 4.59994C1.87256 4.59994 1.57051 4.72634 1.34781 4.95135C1.12511 5.17636 1 5.48153 1 5.79974V14.1983C1 20.1973 5.15625 23.1968 10.1081 24.9245C10.3641 25.0209 10.6451 25.0251 10.9038 24.9365Z",
    stroke: "#005BF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceLogo);
export default __webpack_public_path__ + "static/media/GovernanceLogo.eaf93c5ce0f85c4122c2cbb4972d8d3a.svg";
export { ForwardRef as ReactComponent };